import { Jurisdiction } from "@obg/core.config";
import { TranslationOptions } from "@obg/ngx.core.content";
import CSS from "csstype";

import { WdsDialogProperties } from "./age-verification-dialog.model";

export const WDS_DIALOG_SELECTOR = "wds-dialog";

export const WDS_DIALOG_ACTION_EVENT = "wds-dialog-action";

export const AGE_VERIFICATION_DIALOG_CACHE_KEY = "age-verification-dialog-cache-key";

export const GENERAL_BRAND_LOGO = "general.brand-logo";

export const GENERAL_PREFIX = "general";

export const SECURITY_18_IMAGE = `${GENERAL_PREFIX}.svg-18-primary`;

export const HEADER_SLOT_NAME = "header";

export const TITLE_ICON_SLOT_NAME = "title-icon";

export const WDS_DIALOG_SECONDARY_ACTION_NAME = "wds:dialog-secondary-action";

export const SPONSORSHIP_IMAGE_NAME_WITHOUT_JURISDICTION = `${GENERAL_PREFIX}.sponsorship-image`;

export const OBG_EXPERIMENTS_SOURCE = "obg-experiments";

export const OBG_EXPERIMENT_VALUE = "noagepopup";

export const jurisdictionPropertyDictionary: { [key in Jurisdiction]?: WdsDialogProperties } = {
	[Jurisdiction.LPCSE]: {
		customSizeStyle: {
			width: "327px",
			height: "fit-content",
		},
		responsiveBehavior: "mobile",
		centerTitle: true,
		dialogTitle: "verification.age.dialog.title",
		secondaryTitle: "verification.age.dialog.secondary-title",
		description: "verification.age.dialog.description",
		descriptionStyle: {
			color: "var(--primary)",
			font: "var(--paragraphs-lead-bold)",
		},
		fallbackPrimaryButtonText: "verification.age.dialog.primary-button-text",
		fallbackPrimaryButtonDisabled: true,
		fallbackPrimaryButtonStyle: {
			background: "transparent",
		},
		fallbackSecondaryButtonText: "verification.age.dialog.secondary-button-text",
		fallbackSecondaryButtonTestId: "18-popup.yes",
		enableBlurOnHost: true,
		enableBorderRadius: true,
	},
	[Jurisdiction.Mga]: {
		customSizeStyle: {
			width: "327px",
			height: "fit-content",
		},
		responsiveBehavior: "mobile",
		centerTitle: true,
		dialogTitle: "verification.age.dialog.title",
		secondaryTitle: "verification.age.dialog.secondary-title",
		description: "verification.age.dialog.description",
		descriptionStyle: {
			color: "var(--primary)",
			font: "var(--paragraphs-lead-bold)",
		},
		fallbackPrimaryButtonText: "verification.age.dialog.primary-button-text",
		fallbackPrimaryButtonDisabled: true,
		fallbackPrimaryButtonStyle: {
			background: "transparent",
		},
		fallbackSecondaryButtonText: "verification.age.dialog.secondary-button-text",
		fallbackSecondaryButtonTestId: "18-popup.yes",
		enableBlurOnHost: true,
		enableBorderRadius: true,
	},
};

export const headerStyleDictionary: { [key in Jurisdiction]?: CSS.Properties } = {
	[Jurisdiction.LPCSE]: {
		background: "var(--header)",
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "var(--spacing-medium)",
		padding: "10px 0",
		borderRadius: "var(--spacing-xsmall) var(--spacing-xsmall) 0 0",
	},
	[Jurisdiction.Mga]: {
		background: "var(--header)",
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "var(--spacing-medium)",
		padding: "10px 0",
		borderRadius: "var(--spacing-xsmall) var(--spacing-xsmall) 0 0",
	},
};

export const headerBrandLogoStyleDictionary: { [key in Jurisdiction]?: CSS.Properties } = {
	[Jurisdiction.LPCSE]: { width: "auto", height: "32px" },
	[Jurisdiction.Mga]: { width: "auto", height: "32px" },
};

export const headerSponsorshipLogoStyleDictionary: { [key in Jurisdiction]?: CSS.Properties } = {
	[Jurisdiction.LPCSE]: { width: "auto", height: "32px" },
	[Jurisdiction.Mga]: { display: "none" },
};

export const headerTitleImageLogoStyleDictionary: { [key in Jurisdiction]?: CSS.Properties } = {
	[Jurisdiction.LPCSE]: { width: "75px", height: "71px" },
	[Jurisdiction.Mga]: { width: "75px", height: "71px" },
};

export const separatorStyleDictionary: { [key in Jurisdiction]?: CSS.Properties } = {
	[Jurisdiction.LPCSE]: { width: "1px", height: "30px", background: "var(--on-header)" },
	[Jurisdiction.Mga]: { display: "none" },
};

export const translationCrsKeys: { [key in Jurisdiction]?: TranslationOptions } = {
	[Jurisdiction.LPCSE]: {
		defaultCrsKeys: [
			jurisdictionPropertyDictionary[Jurisdiction.LPCSE]!.dialogTitle!,
			jurisdictionPropertyDictionary[Jurisdiction.LPCSE]!.secondaryTitle!,
			jurisdictionPropertyDictionary[Jurisdiction.LPCSE]!.description!,
			jurisdictionPropertyDictionary[Jurisdiction.LPCSE]!.fallbackPrimaryButtonText!,
			jurisdictionPropertyDictionary[Jurisdiction.LPCSE]!.fallbackSecondaryButtonText!,
		],
		dotMapping: true,
	},
	[Jurisdiction.Mga]: {
		defaultCrsKeys: [
			jurisdictionPropertyDictionary[Jurisdiction.Mga]!.dialogTitle!,
			jurisdictionPropertyDictionary[Jurisdiction.Mga]!.secondaryTitle!,
			jurisdictionPropertyDictionary[Jurisdiction.Mga]!.description!,
			jurisdictionPropertyDictionary[Jurisdiction.Mga]!.fallbackPrimaryButtonText!,
			jurisdictionPropertyDictionary[Jurisdiction.Mga]!.fallbackSecondaryButtonText!,
		],
		dotMapping: true,
	},
};
